export default {
  date: {
    'time-style': {
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric'
    }
  },
  number: {
    EUR: { style: 'currency', currency: 'EUR' },
    USD: { style: 'currency', currency: 'USD' }
  },
  time: {
    hhmmss: {
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric'
    }
  }
};
